import React, { useEffect } from 'react'
import cx from 'classnames'
import { VegaIconFlag } from '../icon/Icon'
import { useTranslation } from 'react-i18next'
import './select.scss'
import { VegaSelectBase } from './VegaSelectResource'
import { components } from 'react-select'
import { useSelector, useDispatch } from 'react-redux'
import { setUserLanguage } from '../../../redux/modules/user/userAction'

export const VegaSelectLang = ({ className }) => {
	const { t, i18n } = useTranslation()
	const dispatch = useDispatch()
	const language = useSelector((state) => state.UserReducer.language)

	const options = [
		{ value: 'fr', label: t('languageFR'), transKey: 'languageFR', language: 'fr' },
		{ value: 'gb', label: t('languageEN'), transKey: 'languageEN', language: 'en' },
		{ value: 'it', label: t('languageIT'), transKey: 'languageIT', language: 'it' },
		{ value: 'es', label: t('languageES'), transKey: 'languageES', language: 'es' },
		{ value: 'hu', label: t('languageHU'), transKey: 'languageHU', language: 'hu' },
		{ value: 'ro', label: t('languageRO'), transKey: 'languageRO', language: 'ro' },
		{ value: 'bg', label: t('languageBG'), transKey: 'languageBG', language: 'bg' },
		{ value: 'nl', label: t('languageNL'), transKey: 'languageNL', language: 'nl' },
		{ value: 'de', label: t('languageDE'), transKey: 'languageDE', language: 'de' },
		{ value: 'cn', label: t('languageCH'), transKey: 'languageCH', language: 'zh-cn' }
	]

	const onChange = (newOption) => {
		if (newOption && language !== newOption.language) {
			i18n.changeLanguage(newOption.language)
			dispatch(setUserLanguage(newOption.language))
		}
	}

	return (
		<VegaSelectBase
			components={{ Option: OptionFlag, ValueContainer: ValueContainer }}
			options={options}
			className={cx('vega_select__container', className)}
			defaultValue={options.find((lang) => lang.language === language)}
			onChange={onChange}
		/>
	)
}

/**
 *
 * @param innerProps Option properties
 * @param selectProps properties of the select component
 * @param label label of the option
 * @param value value of the option
 */
const OptionFlag = ({ innerProps, selectProps, label, value }) => {
	return (
		<div {...innerProps} className={`${selectProps.classNamePrefix}__option`}>
			<VegaIconFlag
				country={value}
				size={24}
				className={`${selectProps.classNamePrefix}__flag`}
			/>
			<div className={`${selectProps.classNamePrefix}__label`}>{label}</div>
		</div>
	)
}

const ValueContainer = ({ children, options, ...props }) => {
	const { selectProps, setValue, getValue } = props
	const { i18n } = useTranslation()
	useEffect(() => {
		if (i18n.language) {
			const selectOption = options.find(
				(option) => option.language === i18n.language.substring(0, 2)
			)

			if (selectOption?.label !== getValue()[0]?.label) {
				setValue(selectOption)
			}
		}
	}, [i18n.language, options, setValue, getValue])

	return (
		components.ValueContainer && (
			<components.ValueContainer
				{...props}
				className={`${selectProps.classNamePrefix}__label`}
			>
				{!!children && (
					<VegaIconFlag
						country={getValue()[0]?.value}
						size={20}
						className={`${selectProps.classNamePrefix}__flag`}
					/>
				)}
				{children}
			</components.ValueContainer>
		)
	)
}
